
import Axios from "axios"
import localforage from "localforage"
const IMAGE_URL = location.origin;
// 下载对应配置文件
async function downloadConfig(src) {
    let fileName = src.split('/').pop()
    let topoConfig = (await localforage.getItem('topoDownloadConfig')) || {}
    if (!topoConfig[fileName]) {
        let res = await Axios.get(src, {
            responseType: 'text',
        })
        topoConfig[fileName] = res.data
        localforage.setItem('topo', topoConfig)
        return topoConfig[fileName]
    }
    return topoConfig[fileName]
}

async function dowloadText(src) {
    let res = await Axios.get(IMAGE_URL + "/" + src, {
        responseType: "text",
    });
    return res.data;
}

// 缓存状态
let cacheState = false

/**
 * 打开对应的配置文件
 * @param {*} param 
 */
export default async function (param) {
    const that = this;

    if (!that.store.data.locked || that.store.data.locked == 0) {
        alert('openTopoConfig模块只能在预览窗口调用')
        return;
    }

    // 切换页面后立即更新数据
    const updataData = function () {
        that.update(that.proc.data.modules);
        that.update(that.proc.data.ctrlMode);
    }

    // 每次打开新页面后初始化舞台配置
    const stageInit = function () {
        that.stageCanvas.inactive();
        that.stageCanvas.lock(2);
        that.stageCanvas.fitView(true, 10);
        that.store.data.grid = false;
        that.store.data.rule = false;
        that.store.options.disableTranslate = false;
        updataData()
    }


    let list = await localforage.getItem('topoConfigList') || []
    const getCloudPages = async () => {
        let res = await this.TopoComponents.getPagesCloud();
        console.log(res);
        let configList = res.data || [];
        for await (let item of configList) {
            let text = await dowloadText(item.url)
            item.text = text
        }
        localforage.setItem('topoConfigList', configList);
        cacheState = true;
        return configList;
    }

    const url = param.params;
    // 判断是否是网络地址
    if (url.startsWith('http')) {
        // 下载网络文件
        downloadConfig(url).then(res => {
            // 解密文件
            let deData = this.deConfig(res);
            this.stageCanvas.open(deData);
            stageInit()
        });
        return;
    }

    try {
        // 尝试转换字符串
        let jsondata = JSON.parse(url);
        this.stageCanvas.open(jsondata);
        stageInit()
    } catch (error) {
        // 传入对象
        if (typeof url === 'object') {
            this.stageCanvas.open(url);
            stageInit()
        } else {
            if (!list.length || !cacheState) {
                list = await getCloudPages()
            }
            let configItem = list.find(item => item.key == url)
            let deData = this.deConfig(configItem.text);
            this.stageCanvas.open(deData);
            stageInit()
        }
    }
}

